import { StyleSheet } from 'react-native';

// Common screen styles to be used across the app
export const commonStyles = StyleSheet.create({
  button: {
    backgroundColor: '#3498db',
    borderRadius: 8,
    marginTop: 20,
    padding: 10,
  },
  buttonText: {
    color: 'white',
    fontWeight: 'bold',
  },
  container: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    padding: 20,
  },
  description: {
    fontSize: 16,
    marginBottom: 20,
    textAlign: 'center',
  },
  logoutButton: {
    backgroundColor: '#e74c3c',
    borderRadius: 8,
    marginTop: 20,
    padding: 10,
  },
  logoutText: {
    color: 'white',
    fontWeight: 'bold',
  },
  safeArea: {
    backgroundColor: '#fff',
    flex: 1,
  },
  scrollContainer: {
    flexGrow: 1,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 10,
  },
});

// Authentication-related styles
export const authStyles = StyleSheet.create({
  backgroundImage: {
    flex: 1,
    height: '100%',
    resizeMode: 'contain',
    width: '100%',
  },
  formContainer: {
    width: '100%',
  },
  input: {
    borderColor: '#ddd',
    borderRadius: 8,
    borderWidth: 1,
    height: 50,
    marginBottom: 15,
    paddingHorizontal: 10,
  },
  link: {
    color: '#3498db',
    fontWeight: 'bold',
  },
  linkContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 20,
  },
  logo: {
    height: 65,
    marginBottom: 10,
    width: 220,
  },
}); 